import { useState } from "react";
import Cart from "../Cart";
import Wrapper from "../../Layout/Wrapper/wrapper";
import SVGS from "../../atoms/svgs";
import { Link } from "gatsby";
import { NavbarShopProps } from "./types";
import "./styles.scss";

const NavbarShop = ({ items, logo }: NavbarShopProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { menu: IconMenu, close: IconClose } = SVGS;

  return (
    <header className="NavbarShop">
      <div className="NavbarShop__logoWrapper">
        <Link
          className="NavbarShop__logoLink"
          to="/">
          <img
            className="NavbarShop__logo"
            src={logo}
            alt="logo"
          />
        </Link>
      </div>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className="NavbarShop__toggle">
        {isOpen ? <IconClose /> : <IconMenu />}
      </button>
      <nav className={`NavbarShop__nav ${!isOpen ? "NavbarShop__inactive" : ""}`}>
        <Wrapper>
          <ul className="NavbarShop__navItems">
            {items.map((item, key) => {
              return (
                <li
                  key={key}
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                  className="NavbarShop__navItem">
                  <Link
                    activeStyle={{ fontWeight: 900 }}
                    className="NavbarShop__navLink"
                    to={item.link}>
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
          <Cart />
        </Wrapper>
      </nav>
      <Cart classWrapper="Cart--mobile" />
    </header>
  );
};

export default NavbarShop;
